<template>
	<app-page>
		<app-heading title="Converge Identities">
			<template v-slot:left>
				<app-button v-if="$ravello.can('studeo.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'converge-identity', params: { identity: 'new' } }"
				>Add Identity</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="identities"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchIdentities"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('studeo.put')"
							color="secondary"
							:to="{ name: 'converge-identity', params: { identity: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('studeo.delete')"
							color="error"
							icon="fa-trash"
							table
							label-confirm="Remove"
							:description="`Are you sure you want to remove identity <b>${item.name}</b>?`"
							title="Remove Identity"
							@click="onDelete(item._id)"
						>
							Remove
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'converge-identity', params: { identity: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			identities: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Enterprise',
				value: 'enterprise.name',
				sortable: true,
			}, {
				text: 'Resort',
				value: 'resort.name',
				sortable: true,
			}, {
				text: 'Is default	resort identity?',
				value: 'is_default',
				sortable: true,
				cb: item => (item.is_default ? 'Yes' : 'No'),
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchIdentities(pagination) {
			const request = this.$ravello.graphql('convergeidentities')
				.include(this.$ravello.graphql('enterprise').field('name'))
				.include(this.$ravello.graphql('resort').field('name'))
				.fromPagination(pagination)
				.fields(['_id', 'name', 'slug', 'is_default'])

			if (this.count === -1) {
				request.count('count')
			}

			try {
				this.identities = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('converge')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
